import React, { useState } from "react";
import { sendPasswordResetEmail } from "firebase/auth";
import { auth } from "./firebase"; // Adjust the path if needed
import "./Forget_password.css";

const ForgetPassword = () => {
  const [email, setEmail] = useState("");
  const [isSent, setIsSent] = useState(false);
  const [error, setError] = useState("");

  const handleSendResetEmail = async () => {
    if (!email) {
      setError("Please enter your email address.");
      return;
    }

    try {
      await sendPasswordResetEmail(auth, email);
      setIsSent(true);
      setError("");
    } catch (err) {
      setError("Failed to send email. Please check the email address.");
      console.error(err);
    }
  };

  return (
    <div className="forget-password-container">
      

      <div className="glass-card">
       
        <button className="back-button" onClick={() => window.history.back()}>
          &#8592;
        </button>
        <h2>Forgot Password</h2>
      
        {!isSent ? (
          <>
            <p>Please enter your email address to receive a password reset link.</p>
            <label>Email Address</label>
            <input
              type="email"
              placeholder="Enter your email"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
            />
            {error && <p className="error-message">{error}</p>}
            <button className="send-button" onClick={handleSendResetEmail}>
              Send Reset Email
            </button>
          </>
        ) : (
          <p className="success-message">
            A password reset link has been sent to your email!
          </p>
        )}
      </div>
    </div>
  );
};

export default ForgetPassword;
